<template>
  <svg
    ADD
    viewBox="0 0 18 18"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M 9 1 L 9 17 M 17 9 L 1 9" bx:origin="0.4375 0.4375" />
  </svg>
</template>

<script>
export default {
  name: "IconAdd"
};
</script>